import { ECalculateActionType } from './types';
import { fetchCalculate, TCalculateResponse } from '../../repositories/investment-calculator-frontend/v1/calculate';
import { selectCurrentMortgageRate } from '../../selectors/mortgageRate';
import { ICalculateResult } from '../../types/calculate';
import { TThunkAction } from '../../types/redux/thunk';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { openCalculateResultModal } from '../calculateResultModal';

const setStatusLoading = actionGenerator<ECalculateActionType.Loading>(ECalculateActionType.Loading);
const setStatusSucceed = actionGenerator<ECalculateActionType.Succeed, ICalculateResult>(ECalculateActionType.Succeed);
const setStatusFailed = actionGenerator<ECalculateActionType.Failed, string>(ECalculateActionType.Failed);

export function calculate(): TThunkAction<Promise<ICalculateResult | null>> {
  return async (dispatch, getState, context) => {
    const { httpApi, config, logger } = context;
    const defaultMortgageRate = config.get<number>('investment-calculator-frontend.mortgageRate') || 7.3;
    const depositRate = config.get<number>('investment-calculator-frontend.depositRate') || 4.5;
    const defaultFlatPriceInc = config.get<number>('investment-calculator-frontend.defaultFlatPriceInc') || 7.1;
    const mortgageRate = selectCurrentMortgageRate(getState());
    const {
      fieldsState: { rentPrice, flatPrice, flatPriceInc, moneyBalance, moneyToSpend },
    } = getState();

    dispatch(setStatusLoading());

    try {
      const calculateResponse: TCalculateResponse = await fetchCalculate({
        httpApi,
        parameters: {
          iHave: moneyBalance || 0,
          flatPrice: flatPrice || 0,
          flatPriceInc: flatPriceInc || defaultFlatPriceInc,
          iCanSave: moneyToSpend || 0,
          mortgageInc: mortgageRate || defaultMortgageRate,
          investInc: depositRate,
          iSpent: rentPrice || 0,
        },
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
          },
        },
      });

      if (calculateResponse.statusCode === 400) {
        dispatch(setStatusFailed(calculateResponse.response.message));

        return null;
      }

      dispatch(setStatusSucceed(calculateResponse.response));
      dispatch(openCalculateResultModal());

      return calculateResponse.response;
    } catch (ex) {
      logger.error(ex);
      dispatch(setStatusFailed('Что-то пошло не так, попробуйте ещё раз'));

      return null;
    }
  };
}
